import { render } from "./ExtraActivityInfo.vue?vue&type=template&id=b6d5a210&scoped=true"
import script from "./ExtraActivityInfo.vue?vue&type=script&lang=js"
export * from "./ExtraActivityInfo.vue?vue&type=script&lang=js"

import "./ExtraActivityInfo.vue?vue&type=style&index=0&id=b6d5a210&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d5a210"]])

export default __exports__